import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-survey-builder-help-content',
  templateUrl: './survey-builder-help-content.component.pug',
  styleUrls: ['./survey-builder-help-content.component.scss'],
  standalone: false
})
export class SurveyBuilderHelpContentComponent {
  @Input() isModal = false;
  @Input() type = 'exit';

  constructor() { }

}
